/* global dataLayer */
/**
 * Tracking
 */

// Import extend function.
import Component from '../../core/component.js';
import '../../vendor/polyfills/polyfill-nodelist-foreach.js';

class Track extends Component {
	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
		return {
			debug: false
		};
	}

	/**
	 * Initialize component
	 */
	_init () {
		if (typeof dataLayer === 'undefined') {
			return;
		}
		this.element = this.settings.element;
		this._bindEvents();
	}
	_bindEvents () {
		this.element.addEventListener('click', () => {
			// Check if the trigger is toggeling and prevent tracking when closing the expanded section
			if (!this.element.hasAttribute('aria-expanded') || this.element.getAttribute('aria-expanded') === 'true') {
				this._handleClickEvent();
			}
		});
	}
	_handleClickEvent() {
		let data;
		data = this.element.getAttribute('data-track-click');
		if (data) {
			let jsonData = data.replace(/'/g, '"');
			try {
				data = JSON.parse(jsonData);
				dataLayer.push(data);
			}
			catch(e) {}
		}
	}
}

document.addEventListener('newcontent', (e) => {
	e.target.querySelectorAll('[data-track-click]').forEach(element => {

		let settings = {
			debug: false,
			element: element
		};

		element.track = new Track(settings);
	});
});

export default Track;



// WEBPACK FOOTER //
// ./js/utilities/track/u-track.js